module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-9-512.beb7eff62974f060.png"+" 512w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-9-512.beb7eff62974f060.png",width: 512,height: 341}],
        src: "https://static.sniffspot.com/packs/img/bp-9-512.beb7eff62974f060.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-9-512.beb7eff62974f060.png"},
        
        width: 512,
        height: 341
      }